import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import type { ShippingCode } from '@aigftpwatch/shared';

export function useShippingCodes(carrier?: string) {
  const params = carrier ? `?carrier=${carrier}` : '';
  return useQuery({
    queryKey: ['shipping-codes', carrier],
    queryFn: () => api.get<ShippingCode[]>(`/shipping-codes${params}`).then((r) => r.data),
    staleTime: 5 * 60_000,
  });
}
